/*
 * AUTO-GENERATED FILE. DO NOT MODIFY
 *
 * This file was automatically generated by the
 * npm run generate-design-token command, and it
 * should not be modified by hand.
 */

export const FabSecondaryBorderWidthPositiveDefault = '1px'
export const FabSecondaryBorderWidthPositiveHovered = '1px'
export const FabSecondaryBorderWidthPositivePressed = '1px'
export const FabSecondaryBorderWidthPositiveDisabled = '1px'
export const FabSecondaryBorderWidthDestructiveDefault = '1px'
export const FabSecondaryBorderWidthDestructiveHovered = '1px'
export const FabSecondaryBorderWidthDestructivePressed = '1px'
export const FabSecondaryBorderWidthDestructiveDisabled = '1px'
export const FabSecondaryColorPositiveDefaultBackground = '#ffffff'
export const FabSecondaryColorPositiveDefaultOnBackground = '#00000099'
export const FabSecondaryColorPositiveDefaultOutline = '#0000001f'
export const FabSecondaryColorPositiveHoveredBackground = '#f3f3f3'
export const FabSecondaryColorPositiveHoveredOnBackground = '#00000099'
export const FabSecondaryColorPositiveHoveredOutline = '#0000001f'
export const FabSecondaryColorPositivePressedBackground = '#eff5f3'
export const FabSecondaryColorPositivePressedOnBackground = '#3E8672'
export const FabSecondaryColorPositivePressedOutline = '#0000001f'
export const FabSecondaryColorPositiveDisabledBackground = '#f3f3f3'
export const FabSecondaryColorPositiveDisabledOnBackground = '#00000061'
export const FabSecondaryColorPositiveDisabledOutline = '#ffffff00'
export const FabSecondaryColorDestructiveDefaultBackground = '#ffffff'
export const FabSecondaryColorDestructiveDefaultOnBackground = '#f4511e'
export const FabSecondaryColorDestructiveDefaultOutline = '#0000001f'
export const FabSecondaryColorDestructiveHoveredBackground = '#fff8f5'
export const FabSecondaryColorDestructiveHoveredOnBackground = '#f4511e'
export const FabSecondaryColorDestructiveHoveredOutline = '#0000001f'
export const FabSecondaryColorDestructivePressedBackground = '#fff2ec'
export const FabSecondaryColorDestructivePressedOnBackground = '#f4511e'
export const FabSecondaryColorDestructivePressedOutline = '#f4511e'
export const FabSecondaryColorDestructiveDisabledBackground = '#f3f3f3'
export const FabSecondaryColorDestructiveDisabledOnBackground = '#00000061'
export const FabSecondaryColorDestructiveDisabledOutline = '#0000001f'
export const FabSecondaryColorWarningDefaultBackground = '#ffffff'
export const FabSecondaryColorWarningDefaultOnBackground = '#fb8c00'
export const FabSecondaryColorWarningDefaultOutline = '#0000001f'
export const FabSecondaryColorWarningHoveredBackground = '#fffaf6'
export const FabSecondaryColorWarningHoveredOnBackground = '#fb8c00'
export const FabSecondaryColorWarningHoveredOutline = '#0000001f'
export const FabSecondaryColorWarningPressedBackground = '#fff6ed'
export const FabSecondaryColorWarningPressedOnBackground = '#fb8c00'
export const FabSecondaryColorWarningPressedOutline = '#fb8c00'
export const FabSecondaryColorWarningDisabledBackground = '#f3f3f3'
export const FabSecondaryColorWarningDisabledOnBackground = '#00000061'
export const FabSecondaryColorWarningDisabledOutline = '#0000001f'
